// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoBubble_wrapper__2nP6M","icon":"InfoBubble_icon__2hE_4","popout":"InfoBubble_popout__QgG8U"};